import type { App } from "vue";

import { createStore, createLogger } from "vuex";

import {
  store as config,
  ConfigStore,
  ConfigState,
} from "@/store/modules/config";

import { State as UserState } from "@/store/modules/user";
import dataMarket from "@/store/modules/dataMarket";
import dataDetail from "@/store/modules/dataDetail";
import user from "@/store/modules/user";
import wallet from "@/store/modules/wallet";
import dataSaler from "@/store/modules/dataSaler";
import orderAudit from "@/store/modules/orderAudit";
import myMessage from "@/store/modules/myMessage";
import message from "@/store/modules/message";
import popup from "@/store/modules/popup";

export interface RootState {
  config: ConfigState;
  user: UserState;
}

export type Store = ConfigStore<Pick<RootState, "config">>;

const debug = process.env.NODE_ENV !== "production";

const plugins = debug ? [createLogger({})] : [];

export const store = createStore({
  plugins,
  modules: {
    config,
    dataMarket,
    dataDetail,
    user,
    wallet,
    dataSaler,
    orderAudit,
    myMessage,
    message,
    popup,
  },
});

export function registerStore(app: App) {
  app.use(store);
}

export function useStore(): Store {
  return store as Store;
}
